import { render, staticRenderFns } from "./FreePerksTopOffer.vue?vue&type=template&id=23ecb54f&scoped=true&"
import script from "./FreePerksTopOffer.vue?vue&type=script&lang=js&"
export * from "./FreePerksTopOffer.vue?vue&type=script&lang=js&"
import style0 from "./FreePerksTopOffer.vue?vue&type=style&index=0&id=23ecb54f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecb54f",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardTitle, BCardText, BButton, BCardBody, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardTitle, BCardText, BButton, BCardBody, BCard})
    

export default component.exports